import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 border text-center fw-bold" }, " Материал "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border text-center fw-bold" }, " Ед изм "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 border text-center fw-bold" }, " Количество "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 border text-center fw-bold" }, " Макс. количество ")
], -1)
const _hoisted_3 = { class: "col-4 border" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "col-2 border d-flex align-items-center" }
const _hoisted_6 = { class: "col-3 border d-flex align-items-center" }
const _hoisted_7 = { class: "col-3 border d-flex align-items-center justify-content-end" }
const _hoisted_8 = { class: "col-12 text-center mt-3" }

import { onMounted, reactive, computed } from "vue";
import { useModal } from "@/composables/useModal";
import api from "@/api";

type materialByLocomotiveType = {
    id: number;
    quantityInStock: number;
    count: number;
    model: string;
    quantity: number;
};

type purchasingMaterialType = {
    quantity: number;
    materialId: number;
    materialName: string;
    unit: string;
    ids: materialByLocomotiveType[];
};

type stateType = {
    id: number;
    visibleErrors: boolean;
    loader: boolean;
    requiredMaterials: purchasingMaterialType[];
};

type payloadType = {
    quantity: number;
    materialId: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ClosePurchaseRequestFromStockModal',
  props: {
    id: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;

const modal = useModal(props.id);
const state: stateType = reactive({
    id: 0,
    visibleErrors: false,
    loader: false,
    requiredMaterials: [],
});
onMounted(() => {
    if (Object.keys(modal.data.payload).length) {
        state.requiredMaterials = modal.data.payload.map((p: purchasingMaterialType) => ({
            ...p,
            ids: p.ids.map((material) => ({
                ...material,
                count: material.quantityInStock,
            }))
        }));
    }
});

const isQuantityError = computed(() => (material: materialByLocomotiveType) => {
    return +material.count < 0 || !isFinite(+material.count) || +material.count > +material.quantity;
});

const isErrorsExist = computed(() => {
    return state.requiredMaterials.some((rm) => rm.ids.some((material) => isQuantityError.value(material)));
});

function send() {
    if (isErrorsExist.value) {
        state.visibleErrors = true;
        return;
    }
    state.visibleErrors = false;
    state.loader = true;
    const payload = state.requiredMaterials.reduce((acc, curVal) => {
        return [...acc, ...curVal.ids.map(material => ({
            materialId: material.id,
            quantity: material.count,
        }))];
    }, [] as payloadType[]);
    api.purchaseRequests.takeFromStock(({ materials: payload })).then(r => {
        modal.ok(r.data);
    })
}


return (_ctx: any,_cache: any) => {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: __props.id,
    size: "modal-md",
    title: "Забрать потребность со склада"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.requiredMaterials, (material) => {
            return (_openBlock(), _createElementBlock("div", {
              key: material.materialId
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(material.ids, (materialByLocomotive) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row col-12",
                  key: materialByLocomotive.id
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("b", null, _toDisplayString(materialByLocomotive.model), 1),
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(material?.materialName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(material?.unit), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_form_group_ui, {
                      "invalid-feedback": "Укажите точное количество",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_input_ui, {
                          class: "mt-2 text-end",
                          modelValue: materialByLocomotive.count,
                          "onUpdate:modelValue": ($event: any) => ((materialByLocomotive.count) = $event),
                          "is-invalid": state.visibleErrors && isQuantityError.value(materialByLocomotive),
                          type: "number",
                          placeholder: "Цена"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("b", null, _toDisplayString(materialByLocomotive.quantity), 1)
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить ")
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}
}

})